<!-- HTML Template -->
<mat-card class="cardWithShadow">
  <mat-card-content>
    <div class="d-flex align-items-center">
      <mat-card-title class="modal-title">Merge Duplicates</mat-card-title>
      <div class="m-l-auto d-flex align-items-center" *ngIf="!previewDetails">
        <button mat-flat-button (click)="keepSeperate()">Keep separate</button>
        <button mat-flat-button color="primary" (click)="preview()">Preview</button>
        <button mat-icon-button class="close-btn" (click)="closeCard()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="m-l-auto d-flex align-items-center" *ngIf="previewDetails">
        <button mat-flat-button (click)="cancel()">Cancel</button>
        <button mat-flat-button color="primary" (click)="merge()">Merge</button>
        <button mat-icon-button class="close-btn" (click)="closeCard()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Add description above the cards -->
    <div class="description m-t-16 m-b-16">
      To manage duplicate leads, select one as the primary lead. The primary lead will retain its details (such as
      campus, program, cohort, etc.), while all associated data from duplicate leads—such as activities, notes, and
      messages—will be merged into the selected primary lead upon completion of the merge.
    </div>

    <div class="taskboard-wrapper">
      <div class="taskboard-list todos">
        <div class="taskboard-header-costum p-y-8 p-x-16 text-white m-b-16">
          <span>Duplicated ({{ duplicatedLeads.length }})</span>
        </div>
        <app-items-dublicate *ngIf="!previewDetails" [duplicatedLeads]="duplicatedLeads"
          (primaryChanged)="updatedPrimary($event)"></app-items-dublicate>
        <app-items-dublicate *ngIf="previewDetails" [duplicatedLeads]="previewDetails"></app-items-dublicate>
      </div>
    </div>
  </mat-card-content>
</mat-card>